import { render, staticRenderFns } from "./quanyi_list.vue?vue&type=template&id=9098c0e4&scoped=true"
import script from "./quanyi_list.vue?vue&type=script&lang=js"
export * from "./quanyi_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9098c0e4",
  null
  
)

export default component.exports